import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlowDefinition } from '../models/flow.model';
import { BaseService } from './base.service';
import { IBaseModel } from '../models/base.model';
import { FinishedFlowInstancesRequestParams, FlowInstancesByInboxRequestParams } from './interfaces/dashboard.interface';
import { AvailableFlowDefinitionsCsv, AvailableFlowDefinitions, FlowInstancesByInbox, FlowInstancesByInboxCsv, FinishedFlowInstances, FinishedFlowInstancesCsv } from '../models/dashboard.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DashboardService extends BaseService {
    controllerRoute = 'Dashboard';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public async getFlowDefinitionsByFlowInboxId(id: string): Promise<IBaseModel<FlowDefinition[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<FlowDefinition[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/GetFlowDefinitionsByFlowInboxId/${id}`));
    }

    public async getResultsFlowInstancesByInbox(data: FlowInstancesByInboxRequestParams): Promise<IBaseModel<FlowInstancesByInbox>> {
        return await firstValueFrom(this.httpClient.post<IBaseModel<FlowInstancesByInbox>>(`${this.apiBaseUrl}/${this.controllerRoute}/GetResultsFlowInstancesByInbox`, data));
    }

    public async exportCsvFlowInstancesByInbox(data: FlowInstancesByInboxRequestParams): Promise<IBaseModel<FlowInstancesByInboxCsv[]>> {
        return await firstValueFrom(this.httpClient.post<IBaseModel<FlowInstancesByInboxCsv[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/ExportCsvFlowInstancesByInbox`, data));
    }

    public async getResultsAvailableFlowDefinitions(): Promise<IBaseModel<AvailableFlowDefinitions>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<AvailableFlowDefinitions>>(`${this.apiBaseUrl}/${this.controllerRoute}/GetResultsAvailableFlowDefinitions`));
    }

    public async exportCsvAvailableFlowDefinitions(): Promise<IBaseModel<AvailableFlowDefinitionsCsv[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<AvailableFlowDefinitionsCsv[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/ExportCsvAvailableFlowDefinitions`));
    }

    public async getResultsFinishedFlowInstances(data: FinishedFlowInstancesRequestParams): Promise<IBaseModel<FinishedFlowInstances>> {
        return await firstValueFrom(this.httpClient.post<IBaseModel<FinishedFlowInstances>>(`${this.apiBaseUrl}/${this.controllerRoute}/GetResultsFinishedFlowInstances`, data));
    }

    public async exportCsvFinishedFlowInstances(data: FinishedFlowInstancesRequestParams): Promise<IBaseModel<FinishedFlowInstancesCsv[]>> {
        return await firstValueFrom(this.httpClient.post<IBaseModel<FinishedFlowInstancesCsv[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/ExportCsvFinishedFlowInstances`, data));
    }
}
